import { Tooltip } from 'bootstrap';

export function getRedirect(searchString) {
	const searchParams = new URLSearchParams(searchString);
	return decodeURIComponent(searchParams.get('redirect'));
}

export function addRedirect(url, redirectUrl) {
	return redirectUrl ?
		url + (url.match( /[?]/g ) ? '&' : '?' ) +
			'redirect=' + encodeURIComponent(redirectUrl)
		:
		url;
}

export function enableTooltips(container) {
	// https://getbootstrap.com/docs/5.3/components/tooltips/#enable-tooltips
	const tooltipTriggerList =
		(container || document).querySelectorAll('[data-bs-toggle="tooltip"]');

	[...tooltipTriggerList].map(element => new Tooltip(element));
}

export function scrollToHash(hash) {
	const element = location.hash && document.getElementById(hash.substring(1));
	element?.scrollIntoView({behavior: 'smooth'});
}

export function setClipboard(text) {
	return navigator.clipboard.writeText(text);
}

